// ================= ELEMENT REFERENCES =================
const cannabisTypeSelect = document.getElementById('cannabis_type');
const decarbWrapper = document.getElementById('decarb-wrapper');

const cannabis_amount = document.getElementById('cannabis_amount');
const cannabis_unit = document.getElementById('cannabis_unit');

const thc_percent = document.getElementById('thc_percent');
const cbd_percent = document.getElementById('cbd_percent');
const solventSelect = document.getElementById('solvent_type');

const infusion_amount = document.getElementById('infusion_amount');
const infusion_unit = document.getElementById('infusion_unit');

const recipe_fat_amount = document.getElementById('recipe_fat_amount');
const recipe_fat_unit = document.getElementById('recipe_fat_unit');

const portions = document.getElementById('portions');
const decarb_status = document.getElementById('decarb_status');

const resultsBox = document.getElementById('cbc-results');
const solvents = {
  butter: { efficiency: 0.93, name: "Butter" },
  coconutoil: { efficiency: 0.93, name: "Coconut Oil" },
  oliveoil: { efficiency: 0.96, name: "Olive Oil" },
  margarine: { efficiency: 0.94, name: "Margarine" },
  avocadooil: { efficiency: 0.92, name: "Avocado Oil" }
};


// ================= TOGGLE DECARB FIELD =================
function toggleDecarbField() {
  if (cannabisTypeSelect.value !== 'plant') {
    decarbWrapper.style.display = 'none';
  } else {
    decarbWrapper.style.display = 'block';
  }
}

// Run on page load
toggleDecarbField();

// Run on change
cannabisTypeSelect.addEventListener('change', toggleDecarbField);


// ================= CALCULATOR =================
document.getElementById('cbc-calc').addEventListener('click', function () {

  /* ================= VALIDATION ================= */
  if (
    !cannabis_amount.value || Number(cannabis_amount.value) <= 0 ||
    !thc_percent.value || Number(thc_percent.value) <= 0 ||
    !infusion_amount.value || Number(infusion_amount.value) <= 0 ||
    !recipe_fat_amount.value || Number(recipe_fat_amount.value) <= 0 ||
    !portions.value || Number(portions.value) <= 0
  ) {
    alert(window.buttercalcvalidationMessage);
    resultsBox.hidden = true;
    return;
  }

  /* ================= CALCULATION ================= */

  const cannabisAmount = parseFloat(cannabis_amount.value);
  const cannabisUnit = cannabis_unit.value;
  const thcPercent = parseFloat(thc_percent.value);
  const cbdPercent = parseFloat(cbd_percent.value) || 0;

  const infusionAmount = parseFloat(infusion_amount.value);
  const infusionUnit = infusion_unit.value;

  const recipeFatAmount = parseFloat(recipe_fat_amount.value);
  const recipeFatUnit = recipe_fat_unit.value;

  const portionsVal = parseInt(portions.value);

  // Convert cannabis to grams
  const cannabis_g = cannabisUnit === 'kg'
    ? cannabisAmount * 1000
    : cannabisAmount;

  // Convert infusion to grams/ml
  let infusion_g = infusionAmount;
  if (infusionUnit === 'kg' || infusionUnit === 'l') infusion_g *= 1000;

  // Convert recipe fat to grams/ml
  let recipe_g = recipeFatAmount;
  if (recipeFatUnit === 'kg' || recipeFatUnit === 'l') recipe_g *= 1000;

  // Raw cannabinoids (mg)
  const thc_raw = cannabis_g * 1000 * (thcPercent / 100);
  const cbd_raw = cannabis_g * 1000 * (cbdPercent / 100);

  /* ================= FIXED DECARB LOGIC ================= */
  let decarbFactor;

  if (cannabisTypeSelect.value !== 'plant') {
    // Concentrates assumed already activated
    decarbFactor = 1;
  } else {
    // Plant material
    decarbFactor = 0.2; // no decarb default
    if (decarb_status.value === 'oven') decarbFactor = 0.9;
    if (decarb_status.value === 'glass_pot') decarbFactor = 0.85;
  }

  // const infusionFactor = 0.7;

  const selectedSolvent = solvents[solventSelect.value];
  const infusionFactor = selectedSolvent
  ? selectedSolvent.efficiency
  : 0.9;


  // Activated cannabinoids
  const thc_total = thc_raw * decarbFactor * infusionFactor;
  const cbd_total = cbd_raw * decarbFactor * infusionFactor;

  // Per gram/ml
  const thc_per_g = thc_total / infusion_g;
  const cbd_per_g = cbd_total / infusion_g;

  // Recipe totals
  const thc_recipe = thc_per_g * recipe_g;
  const cbd_recipe = cbd_per_g * recipe_g;

  // Per serving
  const thc_serving = thc_recipe / portionsVal;
  const cbd_serving = cbd_recipe / portionsVal;

  // Dose label
  let label = 'Low dose';
  if (thc_serving >= 5) label = 'Medium dose';
  if (thc_serving >= 10) label = 'High dose';
  if (thc_serving >= 20) label = 'Extreme dose';

  // Output
  // document.getElementById('per_gram').innerText =
  //   `${thc_per_g.toFixed(1)} mg THC / ${cbd_per_g.toFixed(1)} mg CBD`;

  // document.getElementById('per_serving').innerText =
  //   `${thc_serving.toFixed(1)} mg THC / ${cbd_serving.toFixed(1)} mg CBD`;

  // document.getElementById('dose_label').innerText = label;

  // const warning = document.getElementById('warning');
  // warning.innerText = '';
  if (thc_serving >= 50) {
    // warning.innerText =
    //   'Overwhelming effects possible (50+ mg THC). Not recommended for most users.';
      document.querySelector('.omnisend_wrapper input[name="custom_warning_text"]').value = 'Overwhelming effects possible (50+ mg THC). Not recommended for most users.';
  }

  resultsBox.hidden = false;
  document.querySelector('.omnisend_wrapper').style.display = 'block';
  document.querySelector('.omnisend_wrapper input[name="custom_per_gram"]').value = `${thc_per_g.toFixed(1)} mg THC / ${cbd_per_g.toFixed(1)} mg CBD`;
  document.querySelector('.omnisend_wrapper input[name="custom_per_serving"]').value = `${thc_serving.toFixed(1)} mg THC / ${cbd_serving.toFixed(1)} mg CBD`;
  document.querySelector('.omnisend_wrapper input[name="custom_dose_label"]').value = label;
});